import React from "react";

import useI18nNamespace from "@services/useI18nNamespace";

import { RegistrationListItem } from "./RegistrationListItem.tsx/RegistrationListItem";
import {
  LogoContainer,
  StyledHeading,
  StyledFlex,
  StyledListItemContainer,
  StyledLogo,
} from "./RegistrationInfo.style";

const BRAZE_LOGO =
  "https://s3.us-east-1.amazonaws.com/appboy-images.com/dashboard-assets/dashboard/free-trial-reg/Braze%20logo.svg";

export const RegistrationInfo = () => {
  const { t } = useI18nNamespace("free-trial-registration");

  const listItems = [
    {
      header: t("registration-info-item-1-header", "Create compelling messages on any channel"),
      description: t(
        "registration-info-item-1-desc",
        "Compose engaging, dynamic messages with templates and no-code visual editors"
      ),
      logo: "https://s3.us-east-1.amazonaws.com/appboy-images.com/dashboard-assets/dashboard/free-trial-reg/edit-04.svg",
    },
    {
      header: t("regitration-info-item-2-header", "Orchestrate real-time, consistent journeys"),
      description: t(
        "registration-info-item-2-desc",
        "Design memorable and responsive customer journeys in Braze Canvas"
      ),
      logo: "https://s3.us-east-1.amazonaws.com/appboy-images.com/dashboard-assets/dashboard/free-trial-reg/user-03.svg",
    },
    {
      header: t("registration-info-item-3-header", "Work smarter with BrazeAI™"),
      description: t(
        "registration-info-item-3-desc",
        "See how BrazeAI™ can help you tailor and adapt customer experiences at scale"
      ),
      logo: "https://s3.us-east-1.amazonaws.com/appboy-images.com/dashboard-assets/dashboard/free-trial-reg/magic-wand-01.svg",
    },
  ];

  return (
    <StyledFlex>
      <LogoContainer>
        <StyledLogo src={BRAZE_LOGO} alt="Braze Logo" aria-label="Braze Logo" />
      </LogoContainer>
      <StyledHeading>{t("registration-info-header", "Get started today with a free 14-day trial")}</StyledHeading>
      <StyledListItemContainer direction="column">
        {listItems.map((item, index) => (
          <RegistrationListItem key={index} {...item} />
        ))}
      </StyledListItemContainer>
    </StyledFlex>
  );
};
